<template>
  <!-- 售后处理 -->
  <div v-loading="loading" class="alarmClass">
    <div>
      <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
        <el-row :gutter="24">
          <el-col span="8">
            <el-form-item label="售后单号" prop="code">
              <el-button type="text" @click="openAfterSaleDialog(row)" style="padding: 0;">
                <div>{{ row.code }}</div>
              </el-button>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="服务订单号" prop="orderCode">
              <el-button type="text" @click="showOrderDetail(row.outOrderId)" style="padding: 0;">
                <div>{{ row.orderCode }}</div>
              </el-button>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="订单金额" prop="totalAmount">
              <div>{{ row.totalAmount }}</div>
            </el-form-item>
          </el-col>
          <el-col span="8">
            <el-form-item label="处理状态" prop="afterSalesStatus">
              <el-select v-model="form.afterSalesStatus" placeholder="请选择 处理状态">
                <el-option
                  v-for="item in afterSalesStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="form.afterSalesStatus == '1'" span="8">
            <el-form-item label="是否退款" prop="refundFlag">
              <el-radio-group v-model="form.refundFlag">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="form.refundFlag == 1" span="8">
            <el-form-item label="退款金额" prop="refundTotal" class="form-flex">
              <el-input
                type="text"
                placeholder="请输入 退款金额"
                disabled
                v-model="refundTotal"
              ></el-input>
              <span style="margin-left: 10px;">元</span>
            </el-form-item>
          </el-col>
          <el-col v-if="form.refundFlag == 1" span="24">
            <el-form-item label="退款明细">
              <el-table
                :data="refundList"
                border
                show-summary
                :span-method="mergeSummary"
                style="width: 100%"
              >
                <el-table-column type="index" label="序号" width="50">
                </el-table-column>
                <el-table-column label="订单类型" prop="typeName"></el-table-column>
                <el-table-column label="支付金额（元）" prop="payAmount"></el-table-column>
                <el-table-column label="退款金额（元）" prop="refundAmount">
                  <template slot-scope="scope">
                    <el-form-item :prop="`refundAmount${scope.$index}`" :rules="formRules.refundAmount">
                      <el-input
                        type="text"
                        placeholder="请输入 退款金额"
                        v-model="form[`refundAmount${scope.$index}`]"
                      ></el-input>
                    </el-form-item>                    
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="处理记录" prop="handleRecord">
              <el-input
                type="textarea"
                placeholder="请输入 处理记录"
                v-model="form.handleRecord"
                maxlength="200"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item label="附件上传">
              <VUpload :fileList.sync="handleAttachList" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <hr-dialog
        title="售后详情"
        :allowFull="false"
        width="60%"
        :visible.sync="afterSaleApplyDetailVisible"
      >
        <template slot="body">
          <afterSaleDetails
            :row="formRow"
            @cancle="recordCancle"
            @success="recordSuccess"
            v-if="afterSaleApplyDetailVisible"
          >
          </afterSaleDetails>
        </template>
      </hr-dialog>
      <orderDetail ref="orderDetailRef" v-if="isNeedOrderDetailShow" :orderId="orderId"> </orderDetail>
    </div>
    <div style="text-align: right">
      <el-button type="primary" icon="el-icon-circle-plus-outline" @click="saveRecord" size="small" :disabled="!btnStatus">
        保存
      </el-button>
      <el-button icon="el-icon-circle-close" @click="cancleRecord" size="small"> 取消 </el-button>
    </div>
  </div>
</template>
  <script>
import VUpload from '@/views/components/v-upload';
import afterSaleDetails from './afterSaleDetails.vue';
import orderDetail from './orderDetail.vue';
import { handle } from '@/api/v4ward/out/order/after/sales/outorderaftersales.js';
export default {
  components: {
    VUpload,
    afterSaleDetails,
    orderDetail,
  },
  props: {
    row: {
      default: {},
    },

    model: {
      default: 'add',
    },
  },
  data() {
    return {
      orderId: '', // 工单id
      isNeedOrderDetailShow: false,
      afterSaleApplyDetailVisible: false,
      handleAttachList: [],
      value: '',
      radio: '2',
      tableData: [],
      afterSalesStatusList: [
        {
          value: '1',
          label: '售后完成',
        },
        {
          value: '2',
          label: '售后关闭',
        },
      ],
      form: {
        refundFlag: 0
      },
      formRules: {
        afterSalesStatus: [{ required: true, message: '处理状态不能为空', trigger: 'change' }],
        handleRecord: [{ required: true, message: '处理记录不能为空', trigger: 'blur' }],
      },
      refundList: [
        {
          typeName: '预付款',
          payAmount: '',
          code: 'dropInFee',
          refundAmount: 0
        },
        {
          typeName: '尾款',
          payAmount: '',
          code: 'balancePayment',
          refundAmount: 0
        }
      ],
      btnStatus: true
    };
  },
  created() {
    this.form.id = this.row.id;
    const obj = {}
    this.refundList.forEach((item, index) => {
      obj[`refundAmount${index}`] = 0
    })
    this.form = Object.assign({}, this.form, obj);
    this.handleAttachList = [];
  },
  mounted() {},
  watch: {
    row: {
      handler(newVal) {
        if (newVal.id) {
          this.refundList.forEach((item, index) => {
            item.payAmount = this.row[item.code]
          })
        }
      },
      deep: true,
      immediate: true,
    },
    'form.refundAmount0': {
      handler(newVal) {
        this.refundList[0].refundAmount = Number(newVal)
        this.$forceUpdate();
      },
      immediate: true,
    },
    'form.refundAmount1': {
      handler(newVal) {
        this.refundList[1].refundAmount = Number(newVal)
        this.$forceUpdate();
      },
      immediate: true,
    },
    'form.refundFlag': {
      handler(newVal) {
        if(newVal == 1) {
          this.formRules.refundAmount = [{ validator: this.getAmountRule(), trigger: 'blur' }]
        } else {
          this.formRules.refundAmount = []
        }
      },
      immediate: true,
    },
  },
  computed: {    
    refundTotal() {
      // 使用reduce方法对属性值求和
      const keys = Object.keys(this.form).filter(item => item.includes('refundAmount'));
      let t = keys.reduce((sum, item) => {
        const refundAmountN = Number(this.form[item]);
        if (!isNaN(refundAmountN)) {
          // 小数点的计算需要*100
          sum += refundAmountN * 100;
        }
        return sum;
      }, 0);
      t = t == 0 ? 0 : (t / 100).toFixed(2)
      return t;
    }
  },
  methods: {
    getAmountRule() {
      return (rule, value, callback) => {
        console.log('rule', rule);
        console.log('value', value);
        const ind = rule.field.slice(-1)
        const maxA = this.refundList[ind].payAmount
        const reg = /^\d{1,9}(?:\.\d{1,2})?$/;
        if (this.vdui.isEmpty(value)) {
          callback(new Error('请输入退款金额'));
        } else if (!reg.test(value)) {
          callback(new Error('请输入9位数以内的整数或包含2位小数点的小数'));
        } else if (Number(value) > Number(maxA)) {
          callback(new Error('退款金额不能大于订单金额'));
        } else {
          callback();
        }
      };
    },
    // 合并单元格
    mergeSummary(param) {
    },
    openAfterSaleDialog(row) {
      this.formRow = row;
      this.afterSaleApplyDetailVisible = true;
    },
    /* 显示工单详情 */
    showOrderDetail(orderId) {
      this.orderId = orderId;
      if (this.isNeedOrderDetailShow) {
        this.$refs.orderDetailRef.show();
      } else {
        this.isNeedOrderDetailShow = true;
        this.$nextTick(() => {
          this.$refs.orderDetailRef.show();
        });
      }
    },
    saveRecord() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          if(!this.btnStatus) return
          this.btnStatus = false
          this.form.handleAttachList = this.handleAttachList;
          // 退款信息
          this.form.refundAmount = this.refundTotal;
          this.form.dropInRefund = this.form.refundAmount0;
          this.form.balanceRefund = this.form.refundAmount1;
          handle(this.form).then((res) => {
            this.$message.success('提交成功');
            this.$emit('success');
            this.btnStatus = true
          }).catch(() => {
            this.btnStatus = true
          });
        }
      });
    },
    cancleRecord() {
      this.$emit('cancle');
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
  },
};
</script>
<style scoped lang="scss">
.alarmClass {
  height: 100%;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
}
::v-deep .el-col-8 {
  height: 54px;
}
.form-flex {
  ::v-deep .el-form-item__content {
    display: flex;
  }
}
</style>
  